<template>
  <el-dialog
    title="服务单评价详情"
    :visible.sync="show"
    width="600px"
    center
    @close="$emit('update:show', false)"
    @open="handle_open">
    <el-form ref="form" :model="rating_info" label-width="90px"
             v-loading="is_rating_info_loading"
             @submit.native.prevent
             element-loading-text="正在获取评价信息">
      <el-form-item label="评分">
        <el-rate class="custom_rate" disabled v-model="rating_info.point"/>
      </el-form-item>
      <el-form-item label="标签">
        <el-tag
          :key="tag"
          v-for="tag in rating_info.tag"
          :disable-transitions="false"
          v-text="tag">
        </el-tag>
      </el-form-item>
      <el-form-item label="您说">
        <el-input type="textarea"
                  autosize
                  rows="3"
                  v-model="rating_info.remark"
                  disabled
                  readonly=""/>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
  import {mapState, mapActions, mapGetters} from 'vuex';

  export default {
    name: 'ticket-rate-detail-dialog',
    components: {},
    props: {
      show: {
        type: Boolean,
        default: false
      },
      ticket_id: {
        type: [Number, String]
      }
    },
    data() {
      return {
        rating_info: {},
        is_rating_info_loading: false
      }
    },
    computed: {
      ...mapGetters([
        'sp_id',
      ]),
    },
    watch: {},
    methods: {
      ...mapActions([
        'getTicketRateInfo',
      ]),
      async handle_open() {
        if (!this.ticket_id) {
          this.$emit('update:show', false);
          return;
        }

        this.is_rating_info_loading = true;

        try {
          const {data} = await this.getTicketRateInfo({ticketId: this.ticket_id});
          this.rating_info = data;
        } catch (e) {
        }

        this.is_rating_info_loading = false;
      },
    },
    mounted() {
    }
  }
</script>

<style scoped>
  .el-tag + .el-tag {
    margin-left: 10px;
  }

  .custom_rate {
    padding-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/controls/ticket-rate-detail-dialog.vue